import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { Toaster } from "sonner"
import { I18nextProvider } from "react-i18next"
import { App } from "./app"
import i18n from "./i18n"
import "../styles/globals.css"

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 30_000,
            retry: 1,
        },
    },
})

const root = document.getElementById("root")
if (!root) throw new Error("Root element not found")

createRoot(root).render(
    <StrictMode>
        <I18nextProvider i18n={i18n}>
            <QueryClientProvider client={queryClient}>
                <App />
                <Toaster richColors position="top-right" />
            </QueryClientProvider>
        </I18nextProvider>
    </StrictMode>,
)
